import React, {Component} from "react";
import Proptypes from "prop-types";

class ServiceBotSignup extends Component {
    componentDidMount() {
        (function () {
            var s = document.createElement("script")
            s.src = 'https://js.billflow.io/billflow-embed.js';
            s.async = true
            s.type = "text/javascript"
            var x = document.getElementsByTagName("script")[0]
            x.parentNode.insertBefore(s, x)
        })();
    }

    render() {
        window.servicebotSettings = {
            billing_page_id: "dj7gYENvodQHGIVC7Q6K",
            email: this.props.email,
            hash: this.props.hash,
            handleResponse: this.props.handleResponse,
        };

        return (
            <div id="billflow-embed"></div>
        );
    }
}


ServiceBotSignup.propTypes = {
    email: Proptypes.string.isRequired
};

export default ServiceBotSignup